// © Microsoft Corporation. All rights reserved.

import { enums } from "./enums";

export class ResponsiveClassManager {
    static responsiveClass = "";
    static listeners: {[key: string]: (responsiveClass) => void} = {};
    static isInitialized = false;
    static queryLevels = null;

    public static setWindow(window: any) {
        if (ResponsiveClassManager.queryLevels) { return; }

        ResponsiveClassManager.queryLevels = [
            {
                query: window.matchMedia("(max-width: 943px)"),
                className: enums.responsiveLevels.articleOneBlock
            },
            {
                query: window.matchMedia("(max-width: 640px)"),
                className: enums.responsiveLevels.L0
            },
            {
                query: window.matchMedia("(max-width: 540px) and (max-aspect-ratio: 1/1)"),
                className: enums.responsiveLevels.MobilePopup
            },
            {
                query: window.matchMedia("(max-width: 480px)"),
                className: enums.responsiveLevels.L1
            },
            {
                query: window.matchMedia("(max-width: 340px)"),
                className: enums.responsiveLevels.L2
            }
        ];
    }

    public static addListener(client: any, onChange: (responsiveClass: string) => void) {
        if (ResponsiveClassManager.listeners[client]) { return; }
        ResponsiveClassManager.listeners[client] = onChange;

        !ResponsiveClassManager.isInitialized && ResponsiveClassManager.listenMediaQueries();
    }

    static listenMediaQueries() {
        ResponsiveClassManager.isInitialized = true;
        // Add listeners for each query level
        ResponsiveClassManager.queryLevels.map(queryLevel => queryLevel.query.addListener(() => ResponsiveClassManager.checkMediaQueryLevel(queryLevel)));

        // Check all queryLevels after the next event tick
        setTimeout(() => { ResponsiveClassManager.queryLevels.map(queryLevel => ResponsiveClassManager.checkMediaQueryLevel(queryLevel)); });
    }

    static checkMediaQueryLevel(queryLevel) {
        let classNames= (ResponsiveClassManager.responsiveClass).split(" ").filter(c => c.trim() != "");

        if (queryLevel.query.matches) {
            classNames.push(queryLevel.className);
        } else {
            classNames = classNames.filter(className => className != queryLevel.className);
        }

        ResponsiveClassManager.responsiveClass = classNames.join(" ");
        Object.values(ResponsiveClassManager.listeners).map(fn => fn(ResponsiveClassManager.responsiveClass));
    }
}